import { Grid, Typography } from "@mui/material"
import { useForm } from "react-hook-form"
import { InputComponent } from "../../components/input"
import { LoadingButton } from "@mui/lab"
import { useState } from "react"
import { AuthService } from "../../services/auth"
import { useNavigate, useSearchParams } from "react-router-dom"
import { usePageTitle } from "../../hooks"
import { Storage } from "../../storage"
import useAuth from "../../context/auth"

export const FirstAccess = ({ isClient = true }: { isClient?: boolean }) => {
    usePageTitle("Criar senha")
    type HookFormData = { password: string, confirmPassword: string }

    const {
        register,
        watch,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm<HookFormData>()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [searchParams] = useSearchParams()
    const { setUser, setIsAuthenticated } = useAuth()

    const token = searchParams.get('t')
    const userId = searchParams.get('u')
    const role = searchParams.get('r')

    const savePassword = ({
        password
    }: HookFormData) => {
        setLoading(true)

        AuthService.redefinePassword({
            password: password,
            token: token as string,
            userId: userId as string,
            role: Number(role)
        })
            .then(({ data }) => {
                Storage.saveTokens({
                    access: data.access,
                    refresh: data.refresh
                })
                Storage.saveUser(data?.userData)
                setUser(data?.userData)
                setIsAuthenticated(true)
                navigate(isClient ? "/cliente" : "/parceiro")
                sessionStorage.clear()
            })
            .finally(() => {
                setLoading(false)
            })
    }

    if (!token || !userId || !role) {
        return (
            <Grid
                sx={{
                    height: "calc(100% - 80px)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <Typography variant="body2" textAlign={"center"} width={"70%"} sx={{ opacity: 0.5 }}>Você não tem permissão para acessar essa página</Typography>
            </Grid>
        )
    }

    return (
        <Grid
            container
            sx={{
                height: "calc(100% - 80px)",
                display: "flex",
                gap: "2.5rem",
                flexDirection: "column",
                alignItems: "center",
                paddingBottom: "20px",
                flexWrap: "nowrap"
            }}
        >

            <Typography
                variant="h1"
                textAlign={"left"}
                width={"90%"}
            >Crie uma senha</Typography>

            <Typography
                variant="body1"
                sx={{ opacity: .5 }}
                textAlign={"left"}
                width={"90%"}
            >Para concluir, crie uma senha de no mínimo 4 dígitos.</Typography>

            <Grid
                sx={{
                    width: "100%",
                    display: "flex",
                    gap: "1.5rem",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <InputComponent
                    autoFocus
                    label="Crie sua senha"
                    value={watch("password") || ""}
                    onChangeValue={(value) => setValue("password", value, { shouldValidate: true })}
                    error={!!errors.password}
                    helperText={errors.password?.message}
                    {...register("password", {
                        required: {
                            value: true,
                            message: "Informe uma senha",
                        },
                        minLength: {
                            value: 4,
                            message: "A senha deve conter no mínimo 4 dígitos"
                        }
                    })}
                />

                <InputComponent
                    label="Digite a senha novamente"
                    value={watch("confirmPassword") || ""}
                    onChangeValue={(value) => setValue("confirmPassword", value, { shouldValidate: true })}
                    error={!!errors.confirmPassword}
                    helperText={errors.confirmPassword?.message}
                    {...register("confirmPassword", {
                        required: {
                            value: true,
                            message: "Confirme a senha",
                        },
                        validate: (value) => {
                            if (value !== watch("password")) return "A senha não coincide"
                        }
                    })}
                />

            </Grid>

            <LoadingButton
                variant="contained"
                loading={loading}
                onClick={(handleSubmit(savePassword))}
            >
                Finalizar cadastro
            </LoadingButton>

        </Grid>
    )
}